import { authAction } from "./auth/authAction";
import { boMonActions } from "./category/boMonActions";
import { chuyenNganhActions } from "./category/chuyenNganhActions";
import { coSoActions } from "./category/coSoActions";
import { giangVienActions } from "./category/giangVienActions";
import { heActions } from "./category/heActions";
import { gioiTinhActions } from "./category/gioiTinhActions";
import { khoaActions } from "./category/khoaActions";
import { lopNamHocActions } from "./category/lopNamHocActions";
import { monHocActions } from "./category/monHocActions";
import { nganhActions } from "./category/nganhActions";
import { nhomLopActions } from "./category/nhomLopActions";
import { nhomLopSinhVienActions } from "./category/nhomLopSinhVienActions";
import { layoutActions } from "./common/layoutActions";
import { chuongTrinhDaoTaoActions } from "./ctdt/chuongTrinhDaoTaoActions";
import { chuongTrinhDaoTaoChiTietActions } from "./ctdt/chuongTrinhDaoTaoChiTietActions";
import { chuongTrinhDaoTaoKienThucActions } from "./ctdt/chuongTrinhDaoTaoKienThucActions";
import { chuongTrinhDaoTaoSoSanhActions } from "./ctdt/chuongTrinhDaoTaoSoSanhActions";
import { giaiDoanActions } from "./ke-hoach/giaiDoanActions";
import { keHoachKyActions } from "./ke-hoach/keHoachKyActions";
import { keHoachKyHieuActions } from "./ke-hoach/keHoachKyHieuActions";
import { keHoachLopActions } from "./ke-hoach/keHoachLopActions";
import { keHoachMonActions } from "./ke-hoach/keHoachMonActions";
import { keHoachMonFullPageActions } from "./ke-hoach/keHoachMonFullPageActions";
import { xepTkbChuanBiActions } from "./ke-hoach/xepTkbChuanBiActions";
import { keHoachMonGhepCapActions } from "./ke-hoach/keHoachMonGhepCapActions";
import { keHoachMonHocNamHocHocKyActions } from "./ke-hoach/keHoachMonHocNamHocHocKyActions";
import { keHoachNamActions } from "./ke-hoach/keHoachNamActions";
import { keHoachTuanActions } from "./ke-hoach/keHoachTuanActions";
import { kyDangKyActions } from "./lop-tin-chi/kyDangKyActions";
import { lopTinChiActions } from "./lop-tin-chi/lopTinChiActions";
import { lopTinChiKetQuaActions } from "./lop-tin-chi/lopTinChiKetQuaActions";
import { xepTKBActions } from "./tkb/xepTKBActions";
// import { dangKyHoActions } from "./dang-ky-ho/dangKyHoActions";
import { giaoVienActions } from "./category/giaoVienActions";
import { danhSachLopTinChiActions } from "./lop-tin-chi/danhSachLopTinChiActions";

import { phanGiaoVienActions } from "./tkb/phanGiaoVienActions";
import { phanPhongHocActions } from "./tkb/phanPhongHocActions";

import { monTuongDuongActions } from "./category/monTuongDuongActions";
import { phamViBanActions } from "./category/phamViBanActions";
import { phongHocActions } from "./category/phongHocActions";
import { rangBuocActions } from "./category/rangBuocActions";
import { tangNhaActions } from "./category/tangNhaActions";
import { toaNhaActions } from "./category/toaNhaActions";
import { dangKyHoActions } from "./dang-ky-ho/dangKyHoActions";
import { keHoachHocLaiActions } from "./ke-hoach-hoc-lai/keHoachHocLaiActions";
import { keHoachMonNVActions } from "./ke-hoach/keHoachMonNVActions";
import { caThiActions } from "./tct/caThiActions";
import { dotDongTuiActions } from "./tct/dotDongTuiActions";
import { dotThiActions } from "./tct/dotThiActions";
import { hinhThucThiActions } from "./tct/hinhThucThiActions";
import { lichThiSinhVienActions } from "./tct/lichThiSinhVienActions";
import { monThiActions } from "./tct/monThiActions";
import { phongThiActions } from "./tct/phongThiActions";
import { thiSinhActions } from "./tct/thiSinhActions";
import { tietThiActions } from "./tct/tietThiActions";
import { tuiThiActions } from "./tct/tuiThiActions";
import { thoiKhoaBieuActions } from "./tkb/thoiKhoaBieuActions";
import { xepTKBLopTCActions } from "./tkb/xepTKBLopTCActions";
import { peActions } from "./tkb/peActions";
import { danhSachMoMonActions } from "./lop-tin-chi/danhSachMoMonActions";
import { tongHopHocPhiActions } from "./tong-hop/tongHopHocPhiActions";
import { phongHocTrongKyAction } from "./category/phongHocTrongKyAction";
import { pageSettingActions } from "./common/pageActions";
import { lopActions } from "./category/lopActions";
import { chuongTrinhDaoTaoRangBuocActions } from "./ctdt/chuongTrinhDaoTaoRangBuocActions";
import { hinhThucGiangActions } from "./category/hinhThucGiangActions";
import { dmLoaiDangKyHocActions } from "./category/dmLoaiDangKyHocActions";
import { dmLoaiLopTinChiActions } from "./category/dmLoaiLopTinChiActions";
import { ngayNghiLeActions } from "./category/ngayNghiLeActions";
import { quyDinhSoBuoiTrenTuanActions } from "./category/quyDinhSoBuoiTrenTuanActions";
import { thoiGianHocLopHCActions } from "./category/thoiGianHocLopHCActions";
import { heSoUuTienTKBActions } from "./category/heSoUuTienTKBActions";
import { loaiGioHocActions } from "./category/loaiGioHocActions";
import { gioHocRangBuocActions } from "./category/gioHocRangBuocActions";
import { mlThamSoPhongHocMonHocActions } from "./category/mlThamSoPhongHocMonHocActions";
import { phongBanActions } from "./category/phongBanActions";
import { phongUuTienBuoiActions } from "./category/phongUuTienBuoiActions";
import { phongUuTienNhomActions } from "./category/phongUuTienNhomActions";
import { giangVienBanActions } from "./category/giangVienBanActions";
import { lopBanActions } from "./category/lopBanActions";
import { doiTuongDaoTaoActions } from "./category/doiTuongDaoTaoActions";
import { tongHopThongKeActions } from "./tong-hop-thong-ke/tongHopThongKeActions";
import { dsDoiTuongDuThiActions } from "./tct/dsDoiTuongDuThiActions";
import { keHoachNhomLopActions } from "./ke-hoach/keHoachNhomLopActions";
import { quanLyDangKyActions } from "./quan-ly-dang-ky/quanLyDangKyActions";
import { quyDinhSoTinChiActions } from "./quan-ly-dang-ky/quyDinhSoTinChiActions";
import { lichSuNapDuLieuActions } from "./quan-ly-dang-ky/lichSuNapDuLieuActions";
import { keHoachToanKhoaActions } from "./ke-hoach/keHoachToanKhoaActions";
import { dangKyChuyenNganhActions } from "./dang-ky-chuyen-nganh/dangKyChuyenNganhActions";
import { phanLopChuyenNganhActions } from "./phan-lop-chuyen-nganh/phanLopChuyenNganhActions";
export const rootActions = {
  auth: authAction,
  common: {
    layout: layoutActions,
    pageSetting: pageSettingActions,
  },
  category: {
    chuyenNganh: chuyenNganhActions,
    nganh: nganhActions,
    he: heActions,
    gioiTinh: gioiTinhActions,
    lopNamHoc: lopNamHocActions,
    lop: lopActions,
    nhomLop: nhomLopActions,
    nhomLopSinhVien: nhomLopSinhVienActions,
    monHoc: monHocActions,
    boMon: boMonActions,
    khoa: khoaActions,
    coso: coSoActions,
    giaoVien: giaoVienActions,
    phongHoc: phongHocActions,
    giangVien: giangVienActions,
    tangNha: tangNhaActions,
    toaNha: toaNhaActions,
    rangBuoc: rangBuocActions,
    phamViBan: phamViBanActions,
    monTuongDuong: monTuongDuongActions,
    phongHocTrongKy: phongHocTrongKyAction,
    hinhThucGiang: hinhThucGiangActions,
    loaiDangKyHoc: dmLoaiDangKyHocActions,
    dmLoaiLopTinChi: dmLoaiLopTinChiActions,
    ngayNghiLe: ngayNghiLeActions,
    quyDinhSoBuoiTrenTuan: quyDinhSoBuoiTrenTuanActions,
    thoiGianHocLopHC: thoiGianHocLopHCActions,
    heSoUuTienTKB: heSoUuTienTKBActions,
    loaiGioHoc: loaiGioHocActions,
    gioHocRangBuoc: gioHocRangBuocActions,
    mlThamSoPhongHocMonHoc: mlThamSoPhongHocMonHocActions,
    phongBan: phongBanActions,
    phongUuTienBuoi: phongUuTienBuoiActions,
    phongUuTienNhom: phongUuTienNhomActions,
    giangVienBan: giangVienBanActions,
    lopBan: lopBanActions,
    doiTuongDaoTao: doiTuongDaoTaoActions,
  },
  keHoach: {
    keHoachToanKhoa: keHoachToanKhoaActions,
    keHoachNam: keHoachNamActions,
    keHoachKy: keHoachKyActions,
    keHoachTuan: keHoachTuanActions,
    keHoachLop: keHoachLopActions,
    keHoachMon: keHoachMonActions,
    keHoachMonFullPage: keHoachMonFullPageActions,
    kyHieu: keHoachKyHieuActions,
    giaiDoan: giaiDoanActions,
    ghepCap: keHoachMonGhepCapActions,
    keHoachMonHocNamHocHocKy: keHoachMonHocNamHocHocKyActions,
    keHoachMonNV: keHoachMonNVActions,
    keHoachNhomLop: keHoachNhomLopActions,
    xepTkbChuanBi: xepTkbChuanBiActions,
  },
  chuongTrinhDaoTaoWrapper: {
    chuongTrinhDaoTao: chuongTrinhDaoTaoActions,
    chiTiet: chuongTrinhDaoTaoChiTietActions,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucActions,
    chuongTrinhDaoTaoRangBuoc: chuongTrinhDaoTaoRangBuocActions,
    soSanh: chuongTrinhDaoTaoSoSanhActions,
  },
  lopTinChiWrapper: {
    kyDangKy: kyDangKyActions,
    lopTinChi: lopTinChiActions,
    lopTinChiKetQua: lopTinChiKetQuaActions,
    danhSachLopTinChi: danhSachLopTinChiActions,
    danhSachMoMon: danhSachMoMonActions,
  },
  tkb: {
    thoiKhoaBieu: thoiKhoaBieuActions,
    xepTKB: xepTKBActions,
    phanGiaoVien: phanGiaoVienActions,
    phanPhongHoc: phanPhongHocActions,
    xepTKBLopTC: xepTKBLopTCActions,
    pe: peActions,
  },
  dangKyHoActions,
  toChucThi: {
    monThi: monThiActions,
    phongThi: phongThiActions,
    dotThi: dotThiActions,
    thiSinh: thiSinhActions,
    hinhThucThi: hinhThucThiActions,
    tuiThi: tuiThiActions,
    caThi: caThiActions,
    lichThiSinhVien: lichThiSinhVienActions,
    dotDongTui: dotDongTuiActions,
    tietThi: tietThiActions,
    dsDoiTuongDuThi: dsDoiTuongDuThiActions,
  },
  keHoachHocLai: {
    keHoach: keHoachHocLaiActions,
  },
  tongHop: {
    hocPhi: tongHopHocPhiActions,
    tongHopThongKe: tongHopThongKeActions,
  },
  quanLyDangKy: {
    quanLyDangKy: quanLyDangKyActions,
    quyDinhSoTinChi: quyDinhSoTinChiActions,
    lichSuNapDuLieu: lichSuNapDuLieuActions,
  },
  dangKyChuyenNganh: {
    dangKyChuyenNganh: dangKyChuyenNganhActions,
  },
  phanLopChuyenNganh: {
    phanLopChuyenNganh: phanLopChuyenNganhActions,
  },
};
